import React from 'react';
import { Icon } from '@chakra-ui/react';

export const IconMinus = (props) => (
  <Icon {...props} fill="none">
    <path
      d="M1 15H29"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);
